import type { SingleRecordResponse } from '@stakeholderlabs/types'
import { useApiGet } from '~/composables/api/useBaseFetch'
import type { Article } from '~/types/models'

export const usePagesApi = () => {
  const show = (slug: string, params?: Article.RequestParams) => {
    return useApiGet<SingleRecordResponse<Article.Model>>(`/pages/${slug}`, {
      params,
    })
  }

  return { show }
}
